export class Config {
  public static config = {
    theme: 'default', // default, collapse, horizontal
    themeType: 'default' // default, dark, light
  };
}
